import React from 'react';
import { useApiRequest } from '../../api/useApiRequest';
import { PrimaryProgressButton, SecondaryButton } from '../../shared/Button';
import { Modal, ModalActionButtons, ModalErrorBox, ModalHeader } from '../../shared/Modal';

type Props = {
  projectId: number;
  designId: number;
  isOpen: boolean;
  closeModal: () => void;
  refreshDesigns?: () => void;
};

export const UploadDesignToNetSuiteModal = ({ projectId, designId, isOpen, closeModal, refreshDesigns }: Props) => {
  const uploadToNetSuiteApiRequest = useApiRequest<undefined, UploadToNetSuiteCommand>({
    httpMethod: 'post',
    endpointUrl: `projects/${projectId}/designs/${designId}/upload-to-net-suite`,
  });

  const { inProgress, error } = uploadToNetSuiteApiRequest;

  const sendRequest = () =>
    uploadToNetSuiteApiRequest.sendRequest({
      requestBody: { designId },
      onSuccess: () => {
        refreshDesigns?.();
        closeModal();
      },
    });

  return (
    <Modal isOpen={isOpen}>
      <ModalHeader>Upload Design to NetSuite</ModalHeader>
      <p>Are you sure you wish to upload the Bill of Materials for this Design to NetSuite?</p>
      <p>
        This will overwrite any previously uploaded Bill of Materials for this Design, including any updates that might
        have been made.
      </p>
      <p>This action cannot be undone.</p>
      {error && <ModalErrorBox error={error} />}
      <ModalActionButtons $align="right">
        <SecondaryButton onClick={closeModal} disabled={inProgress}>
          Cancel
        </SecondaryButton>
        <PrimaryProgressButton onClick={sendRequest} inProgress={inProgress}>
          Confirm
        </PrimaryProgressButton>
      </ModalActionButtons>
    </Modal>
  );
};

type UploadToNetSuiteCommand = {
  designId: number;
};
